import styled from 'styled-components'

import Nodata from '~/shared/assets/background/no-data.png'
import theme from '~/shared/styles/theme'

function NoData() {
  return (
    <Wrapper>
      <Image src={Nodata} alt="No data available" />
      <Message>{'데이터가 없습니다.'}</Message>
    </Wrapper>
  )
}

export default NoData

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 36px;
  align-items: center;
  justify-content: center;

  height: 100%;
  padding: 20px;

  background-color: transparent;

  @media ${theme.device.medium} {
    gap: 36px;
    padding: 20px;
  }
`

const Image = styled.img`
  max-width: 100%;
  height: auto;
  margin-bottom: 20px;

  @media ${theme.device.medium} {
    margin-bottom: 20px;
  }
`

const Message = styled.p`
  font-family: NanumSquareNeo-Bold, sans-serif;
  font-size: 36px;
  font-weight: 500;

  @media ${theme.device.medium} {
    font-size: 24px;
  }
`
